(function ($) {
	"use strict";

	$(function () {

		var addedFilesCounter = 0;

		function resetJoinForm() {
			$(".join-form").trigger("reset");
			$("input[name='uploaded_files_json']").val('');
			addedFilesCounter = 0;
			$('.custom-file-label').toggleClass('disable-btn');
			//grecaptcha.reset();
			$('#files h6').each(function () {
				$(this).remove();
			});
		}

		function fillDataProtectionText(res) {
			$(".adatvedelmi").html('');
			$(".adatvedelmi").append('<input type="checkbox" class="form-check-input firstcheck" id="firstcheck">' +
				'<label class="form-check-label firstcheck_label" for="firstcheck">' + res.data.count + '</label>');
		}

		function selectPositionAjax() {
			var data = {
				action: 'ajax_select',
				nonce: selectposition_ajax.nonce,
				selected_position: $(".select-position").val()
			};

			$.ajax({
				type: 'POST',
				url: selectposition_ajax.url,
				data: data,
				success: function (res) {
					fillDataProtectionText(res);
				}
			});
		}

		//if there has been a change event on the select-position select
		$(".select-position").on("change", function () {
			selectPositionAjax();
		});

		//if position selected automatically
		if($('.select-position').val() != undefined) {
			selectPositionAjax();
		}

		// Initialize the jQuery File Upload widget for Join Form
		$('#fileinput').fileupload({
			url: selectposition_ajax.url,
			dataType: 'json',
			autoUpload: false,
			add: function (e, data) {
				var fileSize = data.originalFiles[0]['size'];
				var fileType = data.originalFiles[0]['type'];

				if (addedFilesCounter >= 1){
					swal({
							title: selectposition_ajax.translations.csak_1_fajl,
							text: '',
							icon: 'error',
							confirmButtonClass: 'btn btn-primary-cutted-corner btn-primary-neon m-0',
							buttonsStyling: false
						}
					)
				}
				else if (fileSize > 2000000) {
					swal({
							title: selectposition_ajax.translations.tul_nagy,
							text: '',
							icon: 'error'
						}
					)
				}

				else if (fileType !== 'application/pdf' && fileType !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && fileType !== 'application/msword') {
					swal({
							title: selectposition_ajax.translations.file_format,
							text: '',
							icon: 'error'
						}
					)
				}

				else {
					addedFilesCounter++;
					data.submit();
				}
			},
			done: function (e, response) {
				if(response.result.success === true && response.result.data.status == 'ok'){
					$('.custom-file-label').removeClass('file-error');
					$('.custom-file-label').toggleClass('disable-btn');
					$('.file_error_text').removeClass('show');
					$('.cv-label').removeClass('has-error-text');
					var file = response.result.data.file;
					var file_name = file.name;
					var short_file_name = file_name;
					if (file_name.length > 18)
						short_file_name = file_name.substring(0,18) + '...';
					$('#files').fadeIn().append('<h6 data-file_name="' + file.url + '">' + short_file_name + '<img src="' + selectposition_ajax.themeurl + '/assets/img/delete-btn.png" alt="delete" class="delete-icon"></h6>');
					swal({
							title: selectposition_ajax.translations.sikeres_CV_feltöltés,
							text: '',
							icon: 'success'
						}
					)
				} else {
					swal({
							title: response.result.data.title,
							text: '',
							icon: 'error'
						}
					)
				}
			}
		});

		$(document).on("click", '.delete-icon', function () {
			$(this).parent().remove();
			$('.custom-file-label').toggleClass('disable-btn');
			addedFilesCounter--;
		});

		//add popup with policy link on policy checked
		$(document).on('click', '#firstcheck', function () {
			var text = $(this).next().children()[0].innerHTML;
			var parsed = ($.parseHTML(text));
			var $url = '';

			$.each( parsed, function( i, el ) {
				if (el.nodeName == 'A') {
					$url = parsed[i].getAttribute('href');
				}
			});

			if($(this).is(':checked')) {
				swal({
					title: selectposition_ajax.translations.job_privacy_title,
					content: {
						element: "a",
						attributes: {
							className: "swal-button swal-button--confirm",
							href: $url,
							innerHTML: 'Megnézem!',
							target: '_blank'
						}
					},
					icon: 'info',
					button: {
						text: "×",
						value: true,
						visible: true,
						className: "close-swal-button",
						closeModal: true
					}
				});
			}
		});

		//join
		$(".join-form").on("submit", function (e) {
			e.preventDefault();
			var $this = $(this);

			if (checkFormRequired(this) == false) {

					if ($(".firstcheck").prop('checked') && addedFilesCounter == 1) {
						$(this).find(".join-btn").prop("disabled", true);

						var $input_fn = $('input[name=uploaded_files_json]');
						$input_fn.val('');

						$("#files h6").each(function (i, element) {
							$input_fn.val($(element).data('file_name'));
						});

						var formdata = $this.serializeArray();
						//formdata[formdata.length] = {name: 'recaptcha', value: $(this).find('#g-recaptcha-response').val()};
						$.ajax({
							url: selectposition_ajax.url,
							type: 'POST',
							data: {
								action: "join_form",
								datas: formdata
							},
							success: function (data) {
								var result = JSON.parse(data);
								swal({
									title: result["title"],
									text: result["message"],
									icon: result["icon"],
									button: 'ok'
								});
								if(result['status'] == 'success'){
									resetJoinForm();
								}

							}
						}).done(function (response) {
							$this.find(".join-btn").prop("disabled", false);
						});
					}
					else {
						if (addedFilesCounter == 0) {
							$('.custom-file-label').addClass('file-error');
							$('.file_error_text').addClass('show');
							$('.cv-label').addClass('has-error-text');
							swal({
								title: selectposition_ajax.translations.hiba,
								text: selectposition_ajax.translations.kotelezo_csillag ,
								icon: 'error',
								button: 'ok'
							});
						}

						if (!$(".firstcheck").prop('checked')) {
							$('.firstcheck_label').addClass('has-error-text');
							swal({
								title: selectposition_ajax.translations.hiba,
								text: selectposition_ajax.translations.kerjuk_fogadja_el,
								icon: 'error',
								button: 'ok'
							});
						}
					}
				} else {
				swal({
					title: selectposition_ajax.translations.hiba,
					text: selectposition_ajax.translations.kotelezo_csillag,
					icon: 'error',
					button: 'ok'
				});
			}
		});

		$(".firstcheck").change(function(){
			$('.firstcheck_label').removeClass('has-error-text');
		});

		$(".secondcheck").change(function(){
			$('.secondcheck_label').removeClass('has-error-text');
		});

	});
})(jQuery);
